import { GetMyAlertNotificationDetails,  SetMyAlertNotificationtDetails,  GetDeleteAlertNotificationdetails,SetDeleteAlertNotificationdetails, GetDeleteAllNotifications, GetDeleteAllAlerts, SetIsAlertNotificationApiCalled } from "./AlertNotificationAction";

const dispatchGetMyAlertNotificationDetails = (dispatch: Function) => (userId: any) => {
  dispatch(GetMyAlertNotificationDetails(userId));
};

const dispatchSetMyAlertNotificationDetails = (dispatch: Function) => (data: any) => {
  dispatch(SetMyAlertNotificationtDetails(data));
};
const dispatchGetDeleteAlertNotificationdetails = (dispatch: Function) => (deleteNotification:any) => {
  dispatch(GetDeleteAlertNotificationdetails(deleteNotification));
  
};
const dispatchSetDeleteAlertNotificationdetails = (dispatch: Function) => (deleteNotification: any) => {
  dispatch(SetDeleteAlertNotificationdetails(deleteNotification));
};

const dispatchSetDeleteAllNotifications = (dispatch: Function) => (deleteAllNotifications: any) => {
  dispatch(GetDeleteAllNotifications(deleteAllNotifications));
};
const dispatchSetDeleteAllAlerts = (dispatch: Function) => (deleteAllAlerts: any) => {
  dispatch(GetDeleteAllAlerts(deleteAllAlerts));
};
const dispatchSetIsAlertNotificationApiCalled = (dispatch: Function) => (isAlertNotificationApiCalled: any) => {
  dispatch(SetIsAlertNotificationApiCalled(isAlertNotificationApiCalled));
};
export const AlertNotificationDispatch = {
 
  dispatchGetMyAlertNotificationDetails,
  dispatchSetMyAlertNotificationDetails,
  dispatchGetDeleteAlertNotificationdetails,
  dispatchSetDeleteAlertNotificationdetails,
  dispatchSetDeleteAllNotifications,
  dispatchSetDeleteAllAlerts,
  dispatchSetIsAlertNotificationApiCalled
};
